import React from "react";

import { getMethodLogo } from "./paymentMethodLogos";

export const MethodIcon = ({ method, className, wrapClassName }) => {
  const Icon = getMethodLogo(method);

  if (!Icon) return null;

  const icon =
    typeof Icon === "string" ? (
      <img src={Icon} alt={method.title} className={className} />
    ) : (
      <Icon className={className} />
    );

  if (!wrapClassName) return icon;

  return <span className={wrapClassName}>{icon}</span>;
};
